export { default as Animated } from './Animated';
export { default as CrossFade } from './CrossFade';
export { animateOnRemove, animateOnAdd } from './animatedComponent';
import { addClassName, animationIsRunningOnParent, removeClassName, registerTransitionListener, forceReflow, clearDimensions, getDimensions, setDimensions, setDisplay } from './utils';
export var utils = {
  addClassName: addClassName,
  animationIsRunningOnParent: animationIsRunningOnParent,
  removeClassName: removeClassName,
  registerTransitionListener: registerTransitionListener,
  forceReflow: forceReflow,
  clearDimensions: clearDimensions,
  getDimensions: getDimensions,
  setDimensions: setDimensions,
  setDisplay: setDisplay
};


// WEBPACK FOOTER //
// ./node_modules/inferno-animation/lib/index.js